{
  "fr-FR": {
    "model": {
      "profile": {
        "id": "ID utilisateur",
        "userName": "Nom d’utilisateur",
        "email": "Adresse électronique",
        "emailConfirmed": "Adresse électronique confirmée",
        "phoneNumber": "Numéro de téléphone",
        "phoneNumberConfirmed": "Numéro de téléphone confirmé.",
        "twoFactorEnabled": "Authentification à deux facteurs activée.",
        "lockoutEnd": "Fin de la période de blocage.",
        "lockoutEnabled": "Verrouillage activé.",
        "accessFailedCount": "Nombre d’échecs d’accès.",
        "firstName": "Prénom",
        "lastName": "Nom de famille",
        "picture": "Photo de profil",
        "organisationName": "Organisation",
        "name": "Nom",
        "roles": "Rôles"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Confirmé"
      },
      "action": {
        "resetPassword.tooltip": "Envoyer par courriel les instructions de réinitialisation du mot de passe à l’utilisateur."
      },
      "message": {
        "resetPassword.success": "Un courriel contenant les instructions pour réinitialiser le mot de passe a été envoyé à l’utilisateur."
      }
    }
  }
}